import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { SunIcon, MoonIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';
import { useThemeStore } from '@/stores/theme';
const OPTIONS = [
    { value: 'light', Icon: SunIcon, key: 'light' },
    { value: 'dark', Icon: MoonIcon, key: 'dark' },
    { value: 'system', Icon: ComputerDesktopIcon, key: 'system' },
];
export function ThemeToggle() {
    const { theme, setTheme } = useThemeStore();
    const { t } = useTranslation();
    return (_jsx("div", { className: "inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white p-0.5 dark:border-gray-700 dark:bg-gray-900", children: OPTIONS.map(({ value, Icon, key }) => (_jsx("button", { onClick: () => setTheme(value), title: t(`settings.${key}`), "aria-label": t(`settings.${key}`), className: `flex h-7 w-7 items-center justify-center rounded-full transition ${theme === value
                ? 'bg-arshe-500 text-white'
                : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'}`, children: _jsx(Icon, { className: "h-4 w-4" }) }, value))) }));
}
